export { Modal as BaseModal } from "../styles/BaseModal";
